exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pre-report__body[data-v-3af1b4e4]{\n  background-color: #ffffff;\n  display: flex;\n  align-items: center;\n  flex: inherit;\n  flex-wrap: wrap;\n  padding: 10px;\n  width: 100%;\n}\n\n", ""]);

// exports
